import api from './index'

const BLUESHIFT_LAMBDA_URL = 'https://v2lr4cqaqyogu34ykwy7ivjtd40rfbac.lambda-url.us-east-2.on.aws/'

export async function sendBlueshiftEvent(email: string, eventName: string): Promise<void> {
  // Skip for Yahoo emails
  if (/@yahoo\.com$/i.test(email)) {
    return
  }

  try {
    await api.post(
      `${BLUESHIFT_LAMBDA_URL}?email=${encodeURIComponent(email)}&eventName=${encodeURIComponent(eventName)}`,
      {},
      { timeout: 5000 }
    )
  } catch (error) {
    console.error('Blueshift event error:', error)
  }
}

// Event names
export const BlueshiftEvents = {
  SIGNUP: 'fafSignup',
  FULL_SUBMIT: 'fullsubmit',
  BUYER_SEQUENCE: 'triggerBuyerSequence',
} as const
